export const CUSTOMER = [
    {
        "id": 1,
        "code": "ARC",
        "name": "ARC Inc.",
        "email": "admin@arcinc.com",
        "address": "2000, St Peter",
        "city": "Villey",
        "state": "CA",
        "zip": "123456",
        "country": "US"
    },
    {
        "id": 2,
        "code": "ARC1",
        "name": "ARC1 Inc.",
        "email": "admin1@arcinc.com",
        "address": "2000, St Peter",
        "city": "Villey",
        "state": "CA",
        "zip": "123456",
        "country": "US"
    },
]

export const CUSTOMER_FIELDS = [
    { name: 'code', label: 'Code', rules: [{ required: true, message: 'Please enter the Code!' }] },
    { name: 'name', label: 'Customer Name', rules: [
        { required: true, message: 'Please enter the Name!' },
        { min: 2, message: 'Name must be at least 2 characters' },
    ]},
    { name: 'contact_person', label: 'Contact Person Name'},
    { name: 'email', label: 'Email', rules: [
        { required: true, message: 'Please enter the Email!' },
        { type: 'email', message: 'Please enter a valid email' },
    ]},
    { name: 'address', label: 'Address', rules: [{ required: true, message: 'Please enter the Address!' }] },
    { name: 'city', label: 'City', rules: [{ required: true, message: 'Please enter the City!' }] },
    { name: 'state', label: 'State', rules: [{ required: true, message: 'Please enter the State!' }] },
    { name: 'zip', label: 'Zip', rules: [
      { required: true, message: 'Please enter the Zip!' },
    ]},
    { name: 'country', label: 'Country', rules: [{ required: true, message: 'Please enter the Country!' }] },
    // { name: 'invoice_due_days', label: 'Invoice Due Days', rules: [
    //     { required: true, message: 'Please enter the Invoice due days!' },
    //     { pattern: /^[0-9]+$/, message: 'Please enter valid Invoice due days!' }
    // ] },
];

export const TEAM_MEMBER_FIELDS = [
    { name: 'name', label: 'Team Member Name', rules: [
        { required: true, message: 'Please enter the Name!' },
        { min: 2, message: 'Name must be at least 2 characters' },
    ]},
    { name: 'email', label: 'Email', rules: [
        { required: true, message: 'Please enter the Email!' },
        { type: 'email', message: 'Please enter a valid email' },
    ]},
    { name: 'phone', label: 'Phone'},
    { name: 'is_primary', label: 'Primary Contact?' },
];

export const primaryContactOptions = [
    {
        label: 'Yes',
        value: true,
    },
    {
        label: 'No',
        value: false,
    }
];

export const DEFAULT_SERVER_STATUS = {success: false, code: null, message: null};

export const CUSTOMERBYID_MOCK = {
    "id": 1,
    "code": "ARC",
    "name": "ARC Inc.",
    "email": "admin@arcinc.com",
    "address": "2000, St Peter",
    "city": "Villey",
    "state": "CA",
    "zip": "123456",
    "country": "US"
}

export const SUBSCRIPTIONS_MOCK = [
    {
        "id": "1",
        "product_id": "1",
        "product": {
            "id": "1",
            "name": "Product 1",
            "sku": "SKU-1",
            "description": "Product 1 Description",
            "price": 10,
            "license_type": "Saas",
            "is_active": true
        },
        "start_date": "2025-07-01",
        "end_date": "2025-07-31",
        "unit_price": 1000,
        "discount_percentage": 10,
        "discount_amount": 100,
        "amount": 900,
        "is_active": true
    },
    {
        "id": "2",
        "product_id": "1",
        "product": {
            "id": "1",
            "name": "Product 1",
            "sku": "SKU-1",
            "description": "Product 1 Description",
            "price": 10,
            "license_type": "Saas",
            "is_active": true
        },
        "start_date": "2025-07-03",
        "end_date": "2025-07-31",
        "unit_price": 1000,
        "discount_percentage": 100,
        "discount_amount": 1000,
        "amount": 0,
        "is_active": true
    },
]

export const INVOICES_MOCK = [
    {
        "id": 1,
        "customer": "Customer 1",
        "invoice_date": "2025-07-03",
        "total": 500.00,
    },
    {
        "id": 2,
        "customer": "Customer 1",
        "invoice_date": "2025-07-10",
        "total": 100.00,
    }
]